// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".f4072315f832c9ff167cd76ca2eb0f96.js";
};